import { Loader2, RotateCcw } from 'lucide-react';

import {
  countReadySlots,
  isAnySlotSeeding,
  isRosterAvailable,
  useDemoRosterQuery,
  useReseedDemoPatientsMutation,
} from '@/entities/sandbox-demo';
import { Button } from '@/shared/ui/shadcn/button';

export function SandboxDemoProgressStrip() {
  const { data: roster } = useDemoRosterQuery();
  const reseed = useReseedDemoPatientsMutation();

  if (roster === undefined || !isRosterAvailable(roster)) {
    return null;
  }
  const failed = roster.slots.filter((slot) => slot.state.type === 'failed');
  const seeding = isAnySlotSeeding(roster);
  if (!seeding && failed.length === 0) {
    return null;
  }

  const ready = countReadySlots(roster);
  const total = roster.slots.length;

  return (
    <section
      aria-live="polite"
      className="mt-6 rounded-xl border border-white/10 bg-white/5 px-5 py-4 text-sm text-white/80 backdrop-blur"
    >
      {seeding ? (
        <div className="flex items-center gap-2">
          <Loader2 className="size-4 animate-spin text-white/60" aria-hidden="true" />
          <span>
            Preparing your demo patients, {ready} of {total} ready
          </span>
        </div>
      ) : null}
      {failed.length > 0 ? (
        <ul className="mt-2 space-y-1">
          {failed.map((slot) => (
            <li key={slot.slug} className="flex items-center justify-between gap-3">
              <span className="text-red-300">
                {slot.display_name} could not be prepared
                {slot.state.type === 'failed' ? `: ${slot.state.error_summary}` : ''}
              </span>
              <Button
                type="button"
                size="sm"
                variant="secondary"
                disabled={reseed.isPending}
                onClick={() => reseed.mutate([slot.slug])}
              >
                <RotateCcw className="size-3.5" aria-hidden="true" />
                Retry
              </Button>
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}
